import React, { PureComponent } from 'react';
import { Modal, Spin } from 'antd';
import PinNumber from '../PinNumber';
import Wrapper from './style';

class Popup extends PureComponent {
	render() {
		const {
			visible,
			onOk,
			onCancel,
			title,
			header,
			isLoading,
			hideBack,
			description
		} = this.props;
		return (
			<Modal
				visible={visible}
				title={null}
				footer={null}
				onCancel={onCancel}
				width={300}
				wrapClassName={hideBack ? 'pin-popup hide-background' : 'pin-popup'}
			>
				<Wrapper>
					<h2>{header}</h2>
					<div className="description">{description}</div>
					<p style={{ padding: '8px 0', margin: 0 }}>
						<b>{title}</b>
					</p>
					<PinNumber onOk={onOk} />
					{!isLoading ? null : <Spin />}
				</Wrapper>
			</Modal>
		);
	}
}

Popup.defaultProps = {
	isLoading: false,
	description: '',
	hideBack: false
};

export default Popup;
